var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconStandard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1826 3.75H2.80762C2.70449 3.75 2.62012 3.83437 2.62012 3.9375V5.4375C2.62012 5.54062 2.70449 5.625 2.80762 5.625H21.1826C21.2857 5.625 21.3701 5.54062 21.3701 5.4375V3.9375C21.3701 3.83437 21.2857 3.75 21.1826 3.75ZM21.1826 18.375H2.80762C2.70449 18.375 2.62012 18.4594 2.62012 18.5625V20.0625C2.62012 20.1656 2.70449 20.25 2.80762 20.25H21.1826C21.2857 20.25 21.3701 20.1656 21.3701 20.0625V18.5625C21.3701 18.4594 21.2857 18.375 21.1826 18.375ZM21.1826 11.0625H2.80762C2.70449 11.0625 2.62012 11.1469 2.62012 11.25V12.75C2.62012 12.8531 2.70449 12.9375 2.80762 12.9375H21.1826C21.2857 12.9375 21.3701 12.8531 21.3701 12.75V11.25C21.3701 11.1469 21.2857 11.0625 21.1826 11.0625Z",
    fillOpacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStandard);
export default __webpack_public_path__ + "static/media/IconStandard.46f5655d642fecf798774e5e265f2a54.svg";
export { ForwardRef as ReactComponent };